/*
 * 3D CSS Typography Component - React Version
 *
 * Original by: Guilleano Cardona
 * Source: https://codepen.io/Guilleano-Cardona/pen/dyrzKqm
 * License: CodePen License (typically MIT/Open Source)
 *
 * Modifications: Adapted for React component, text changed to "Sailing Ships",
 * enhanced centering, and transparent background for banner usage.
 * Original 3D layering system and animation preserved.
 */

import React from "react";
import PropTypes from "prop-types";
import "./Typography.css";

const Typography = ({ text = "Sailing Ships!", transparent = false }) => {
  // Generate 20 layers for the 3D effect
  const layers = Array.from({ length: 20 }, (_, i) => <div key={i} className="layer"></div>);

  return (
    <div className={`typography-container ${transparent ? "transparent" : ""}`}>
      <div className="stage">{layers}</div>
    </div>
  );
};

Typography.propTypes = {
  text: PropTypes.string,
  transparent: PropTypes.bool,
};

export default Typography;
